var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMobileCrmGray = function SvgMobileCrmGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#676879",
    fillRule: "evenodd",
    d: "M9.645 14.582a6.205 6.205 0 0 1-2.483-4.355.07.07 0 0 1 .07-.077h6.105c.308 0 .557-.25.557-.557 0-2.84-2.086-5.21-2.853-5.8a.068.068 0 0 1 .02-.118 6 6 0 0 1 2.008-.258c3.146.12 5.701 2.697 5.798 5.844a6.04 6.04 0 0 1-9.22 5.324z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#676879",
    fillRule: "evenodd",
    d: "M.322 9.33c.132-3.205 2.744-5.813 5.95-5.939a6.17 6.17 0 0 1 3.354.827 6.2 6.2 0 0 1 3.07 4.74.07.07 0 0 1-.07.076H6.521a.554.554 0 0 0-.558.548c0 3.182 2.343 5.4 2.733 5.715a.068.068 0 0 1-.018.117A6.208 6.208 0 0 1 .32 9.332z",
    clipRule: "evenodd"
  })));
};
export default SvgMobileCrmGray;